module.exports = __webpack_public_path__ + "static/media/postcodeBgImage-2x.04994848.png";